import React from 'react';
import Image from '../../../components/AppImage';

const ClientLogoGrid = ({ clients }) => {
  return (
    <div className="bg-card rounded-lg p-4 md:p-6 lg:p-8 shadow-sm">
      <h3 className="text-lg md:text-xl font-semibold text-foreground mb-6 text-center">
        Trusted by Leading Organizations
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
        {clients?.map((client, index) => (
          <div
            key={index}
            className="flex items-center justify-center p-4 bg-muted rounded-lg hover:bg-muted/70 transition-colors duration-200"
          >
            <Image
              src={client?.logo}
              alt={client?.logoAlt}
              className="w-full h-12 md:h-16 object-contain opacity-70 hover:opacity-100 transition-opacity duration-200"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientLogoGrid;